import React, { useState } from 'react';
import { Device } from '../../lib/types';
import Modal, { ModalTitle, ModalActions } from '../../components/Modal/Modal';
import { PortalField } from '../../components/FormField/PortalField';
import { PortalInput } from '../../components/FormField/PortalInput';
import Button from '../../components/Button/Button';
import styles from './Devices.module.scss';

interface TransferToFosterModalProps {
  open: boolean;
  onClose: () => void;
  device: Device | null;
  onTransfer: (deviceId: string, firstName: string, lastName: string, fosterEmail: string, fosterPhone: string) => void;
}

export default function TransferToFosterModal({ open, onClose, device, onTransfer }: TransferToFosterModalProps) {
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');

  if (!device) {
    return null;
  }

  const currentDevice = device;

  function handleClose() {
    setFirstName('');
    setLastName('');
    setEmail('');
    setPhone('');
    onClose();
  }

  function handleConfirm() {
    if (!firstName.trim() || !email.trim()) {
      return;
    }
    onTransfer(currentDevice.id, firstName.trim(), lastName.trim(), email.trim(), phone.trim());
    handleClose();
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <ModalTitle>Assign to foster</ModalTitle>
      <p className={styles.modalDescription}>
        Transfer <strong>{currentDevice.id}</strong>
        {currentDevice.petName ? ` (${currentDevice.petName})` : ''} to a foster.
      </p>

      <PortalField label="Foster name">
        <div className={styles.fieldRow}>
          <PortalInput value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="First name" />
          <PortalInput value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder="Last name" />
        </div>
      </PortalField>

      <PortalField label="Foster email">
        <PortalInput
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="e.g. lisa@gmail.com"
        />
      </PortalField>

      <PortalField label="Foster phone">
        <PortalInput
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="e.g. (555) 123-4567"
        />
      </PortalField>

      <ModalActions>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="green" onClick={handleConfirm}>
          Assign to Foster
        </Button>
      </ModalActions>
    </Modal>
  );
}
